import React, { useState } from 'react';
import { ChevronDown, Search } from 'lucide-react';
import ChatListItem from '@/js/components/chat/ChatListItem';
import ProjectFilter from '@/js/components/chat/ProjectFilter';

const ChatList = ({
  chatList,
  isLoading,
  error,
  projects,
  onSelectChat,
  onClose,
  onRefresh,
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedProject, setSelectedProject] = useState(null);

  // Filter chats based on search and project
  const filteredChats = chatList.filter((chat) => {
    const matchesSearch =
      !searchTerm ||
      chat.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      chat.lastMessage.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesProject =
      !selectedProject || chat.projectId === selectedProject;

    return matchesSearch && matchesProject;
  });

  return (
    <div className="w-[320px] bg-white flex flex-col overflow-hidden">
      {/* Header */}
      <div className="bg-purple-200 text-gray-800 px-4 py-2 flex justify-between items-center">
        <span className="text-base font-medium">Messages</span>
        <button onClick={onClose}>
          <ChevronDown className="h-6 w-6" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto px-2 pt-3">
        {/* Project filter */}
        <ProjectFilter
          projects={projects}
          selectedProject={selectedProject}
          onSelectProject={(id) => setSelectedProject(id)}
          onRefresh={onRefresh}
        />

        {/* Search */}
        <div className="mt-1 py-2 w-full relative">
          <span className="absolute inset-y-0 left-3 flex items-center text-gray-400">
            <Search className="h-5 w-5" />
          </span>
          <input
            type="text"
            placeholder="Search message"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pl-10 border-0 bg-gray-50 rounded px-4 py-2 w-full focus:outline-none placeholder:text-sm placeholder:font-semibold"
          />
        </div>

        {/* Chat list */}
        <div className="flex-1 overflow-y-auto space-y-3 mt-1">
          {isLoading ? (
            <div className="flex justify-center py-4">Loading chats...</div>
          ) : error ? (
            <div className="text-red-500 text-center py-4">{error}</div>
          ) : filteredChats.length === 0 ? (
            <div className="text-center py-4 text-gray-500">
              {searchTerm ? 'No chats match your search' : 'No chats found'}
            </div>
          ) : (
            filteredChats.map((chat) => (
              <ChatListItem
                key={chat.roomId}
                chat={chat}
                onSelect={onSelectChat}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatList;
